import { render } from "./DoctorSchedule.vue?vue&type=template&id=64934de8&scoped=true"
import script from "./DoctorSchedule.vue?vue&type=script&lang=js"
export * from "./DoctorSchedule.vue?vue&type=script&lang=js"

import "./DoctorSchedule.vue?vue&type=style&index=0&id=64934de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64934de8"]])

export default __exports__